import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot explicitly
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

// Create root using React 18's createRoot API
const container = document.getElementById('root');
const root = createRoot(container); // Create a root

// Render your app using the root
root.render(
    <BrowserRouter>
        <React.StrictMode>
            <App />
            <ToastContainer />
        </React.StrictMode>
    </BrowserRouter>
);
